import * as React from 'react';
import classNames from 'classnames';

import * as style from './Field.css';

export interface IFieldProps {
  noPadding?: boolean;
  published?: boolean;
  className?: string;
}

export const Field: React.FC<React.PropsWithChildren<IFieldProps>> = props => {
  const { children, noPadding, className, published = true } = props;

  return (
    <div
      className={classNames(
        style['field'],
        className,
        noPadding && style['field--no-padding'],
        !published && style['field--unpublished'],
      )}
    >
      {children}
    </div>
  );
};
